module.exports = __webpack_public_path__ + "files/a529ad2f7f3a127ca7c118f4670b50c5.png";